import React from 'react';
import { useMst } from '../models/WithWineState';
import { observer, useLocalStore } from 'mobx-react-lite';
import styled from 'styled-components/macro';
import { ProductHero } from './ProductHero';
import { TypeProduct } from '../types/TypeProduct';
import { ProductDetailDivProps } from '../types/ProductDetailsProps';
import { CartActionOption } from '../types/CartItemProps';

const UnstyledProductDetails: React.FC<ProductDetailDivProps> = observer(
  (props) => {
    const stateTree = useMst();
    const priceFormat = props.pricing;
    const carrot = props.carrot;
    const productId = props.product_id || props.product?.id;

    const state = useLocalStore(() => ({
      get product() {
        if (!productId) {
          return stateTree.data.products.values().next().value as TypeProduct;
        }
        return stateTree.data.products.get(productId) as TypeProduct;
      },
    }));

    return state.product ? (
      <div
        className={'ww-widget ww-product-details ' + (props.className ?? '')}
        data-product-id={state.product?.id}
      >
        {state.product ? (
          <ProductHero
            variationsort={props.variationsort}
            data={state.product}
            labels={[]}
            priceFormat={priceFormat}
            carrot={carrot}
            enablevariations={props.enablevariations}
            likebutton={props.likebutton}
            buybutton={props.buybutton}
            trybutton={props.trybutton}
            cartaction={props.cartaction ?? CartActionOption.ShowCart}
            toasteroptions={props.toasteroptions ?? {}}
          />
        ) : (
          <p className="message">
            Sorry, the product you requested could not be found or is no longer
            available
          </p>
        )}
      </div>
    ) : (
      <></>
    );
  },
);

const ProductDetails = styled(UnstyledProductDetails)`
  margin: 0 auto;
  display: flex;
  justify-content: center;

  .message {
    padding: 5em;
    color: var(--gray-3);
    opacity: 0;
  }
`;

export default ProductDetails;
